import React, { Component } from 'react';
import { loadState } from "../../../LocalStore/localStorage";

export class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userInfo: loadState('userInfo'),
        }
    }

    render() {
        const { userInfo } = this.state;
        return (
            <>
                {userInfo &&
                    <footer className="footerWrap">
                        <div className="footerBottom">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-md-6 col-sm-6 col-12">
                                        <div className="footerCopyRight">
                                            <p className="copy">&copy; 2020 <a href="#">Purple Digit Communication Ltd</a>.  All rights reserved.</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-12">
                                        <div className="footerSocial">
                                            <div className="solialLink">
                                                <span>Find us On:</span>
                                                <span>
                                                    <a href="#"><i className="fa fa-facebook"></i></a>
                                                    <a href="#"><i className="fa fa-twitter"></i></a>
                                                    <a href="#"><i className="fa fa-youtube-play"></i></a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                }
            </>
        );
    }
}

export default Footer;
